import React, { useEffect, useState } from 'react';
import { Modal, Button, Dropdown } from 'pepsico-ds';
import { TextField } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { DeleteOutline } from '@mui/icons-material';
import { weightDropdownOptions } from '../../utils/Constants';

const WeightsModal = (props) => {
  const { showModal, handleClose, saveWeightInputs, weightInputs } = props;
  let initialState = weightInputs?.length === 0 ? [{ id: 1 }] : weightInputs;
  const [weightFormInputs, setWeightFormInputs] = useState(initialState);

  const addWeightsForm = () => {
    let ids = weightFormInputs?.map((item) => item.id);
    const maxId = ids?.length === 0 ? 0 : Math.max(...ids);
    setWeightFormInputs([...weightFormInputs, ...[{ id: maxId + 1 }]]);
  };

  const handleDeleteWeightInput = (id) => {
    setWeightFormInputs(weightFormInputs?.filter((item) => item.id !== id));
  };

  const handleChange = async (value, id) => {
    let data = weightFormInputs;
    let filteredData = await data?.map((item) => {
      if (item.id === id) {
        if (value === undefined) {
          item = { id: item.id };
        } else {
          item = { id: item.id, [value]: '' };
        }
      }
      return item;
    });
    setWeightFormInputs(filteredData);
  };

  const handleWeightInput = async (event, list) => {
    let data = weightFormInputs;
    const newValue = event.target.value;
    let filteredData = await data?.map((item) => {
      if (item.id === list?.id) {
        if (newValue === undefined) {
          item = { id: item.id };
        } else {
          let key = Object.keys(item)?.[1];
          item = {
            id: item.id,
            [key]: Number(newValue)
          };
        }
      }
      return item;
    });
    if (/^\d*$/.test(newValue)) setWeightFormInputs(filteredData);
  };

  const getSelectedValue = (value) => {
    return value ? [{ displayText: value, id: value }] : [];
  };

  const getNewFilteredOptions = (allOptions, itemObj) => {
    let data = weightFormInputs;
    let arr = [];
    data?.map((item) => {
      arr = [...arr, ...Object.keys(item)];
    });
    let filteredArr = arr?.filter((li) => li !== 'id');
    let value = Object.keys(itemObj)?.length > 1 ? Object.keys(itemObj)?.[1] : '';
    return [
      ...[{ displayText: value, id: value }],
      ...(allOptions?.filter((option) => !filteredArr?.includes(option.displayText)) ?? [])
    ]?.filter((item) => item.id !== '');
  };

  const getCount = () => {
    let sum = 0;
    weightFormInputs?.forEach((item) => {
      Object.keys(item)?.forEach((key) => {
        if (key !== 'id') {
          sum += Number(item[key]);
        }
      });
    });
    return sum;
  };

  const handleSave = () => {
    let count = getCount();
    if (count !== 100) {
      alert('Weight should be equal to 100%');
    } else {
      saveWeightInputs(weightFormInputs);
      handleClose();
    }
  };

  useEffect(() => {
    setWeightFormInputs(weightInputs);
  }, [Number(weightInputs?.length)]);

  return (
    <Modal
      className="weight-modal"
      showModal={showModal}
      closeOnOutsideClick={false}
      primaryButtonProps={{
        onClick: () => handleSave(),
        size: 'medium',
        text: 'Save',
        variant: 'primary'
      }}
      secondaryButtonProps={{
        onClick: () => setWeightFormInputs([{ id: 1 }]),
        size: 'medium',
        text: 'Clear Selection',
        variant: 'secondary'
      }}
      showAuxiliaryButton={false}
      showTertiaryButton={false}
      showLink={false}
      type={'S'}
      onCloseModal={() => handleClose()}>
      <div>
        <h3 className="weights-modal-title">Set Weights</h3>
        <div className="weights-info-container">
          <InfoOutlinedIcon />
          <span className="weights-info-container-text">Weight should sum to 100%</span>
        </div>
        <table className="weights-table">
          <tr>
            <th>Metric</th>
            <th>{'Weight (%)'}</th>
          </tr>
          {weightFormInputs?.map((item) => (
            <tr key={item?.id}>
              <td>
                <Dropdown
                  data-testid="metric-dropdown"
                  className="metric-dropdown"
                  childList={getNewFilteredOptions(weightDropdownOptions, item)}
                  isClearable
                  placeholder="Select"
                  selection="single"
                  selectedValue={getSelectedValue(Object.keys(item)?.[1])}
                  setSelectedValue={(value) => handleChange(value?.[0]?.displayText, item?.id)}
                  style={{
                    margin: '0px 10px'
                  }}
                />
              </td>
              <td className="weight-input">
                <TextField
                  data-testid="weight-input-value"
                  className="weight-action-input"
                  value={item?.[Object.keys(item)?.[1]] || ''}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: 32 // Adjust the height of the input here
                    }
                  }}
                  inputProps={{
                    inputMode: 'numeric', // Hints to mobile devices to show a numeric keyboard
                    pattern: '[0-9]*' // Restrict input to digits
                  }}
                  onChange={(event) => handleWeightInput(event, item)}
                />
                <DeleteOutline
                  className="weight-delete-icon"
                  onClick={() => handleDeleteWeightInput(item.id)}
                />
              </td>
            </tr>
          ))}
        </table>
        <div className="total-weight-container">
          <span>Total Weight</span>
          <span
            data-testid="weights-count"
            className="total-weight-percentage">{`${getCount()}%`}</span>
        </div>
        <Button
          data-testid="add-weights"
          size="medium"
          text="+ Add Metric"
          variant="tertiary"
          onClick={() => addWeightsForm()}
        />
      </div>
    </Modal>
  );
};

export default WeightsModal;
